import gsap from "gsap";
import { Ticker } from "pixi.js";

export const configuratedStage = (stageRef) => {
    window.__PIXI_APP__ = stageRef.current.app;
    gsap.ticker.remove(gsap.updateRoot);
    Ticker.shared.add(() => {
        gsap.updateRoot(performance.now() / 1000);
    });
}